import { JSX, useContext } from "react";
import { Unauthorized } from "@app/shared/ErrorPages";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { EditTutorialsList } from "@app/admin/tutorials/EditTutorialsList"
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import { Accordion } from "@app/shared/Accordion";
import { AccordionContainer } from "@app/shared/AccordionContainer";
import { breadcrumbTemplates, BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import Roles from "@app/user/roles";
import { UserContext } from "@app/user/UserContext";

const EditTutorials = (): JSX.Element => {
  const userContext = useContext(UserContext);
  const breadcrumbs = breadcrumbTemplates[BreadcrumbTemplateEnum.ManageTutorials];

  if (!userContext.roles.includes(Roles.QUEST_DOCUMENT_ADMIN)) {
    return <Unauthorized/>;
  }

  return (
    <Page documentTitle="Manage Tutorials - Admin">
      <Breadcrumbs
        items={breadcrumbs}
      />
      <PageInner>
        <PageHeader title="Manage Tutorials" iconName={QesIcons.PencilV1}></PageHeader>

        <PageSection>
          <div className="col-12 col-sm-8 mt-3">
            {renderHeaderRow("Updates")}
            <div className="card-striped">
              <AccordionContainer>
                <Accordion title="QAS Web Learning Series" testId="edit-tutorials__qas-web-learning-series-accordion">
                  <EditTutorialsList containerName="new-features" friendlyName="QAS Web Learning Series" enableHyperlink={true} />
                </Accordion>
                <Accordion title="QAS User Guides" testId="edit-tutorials__qas-user-guides-accordion">
                  <EditTutorialsList containerName="webinars" friendlyName="QAS User Guides" enableHyperlink={true} />
                </Accordion>
                <Accordion title="QES What's New Webinars" testId="edit-tutorials__whats-new-webinar-accordion">
                  <EditTutorialsList containerName="whats-new-webinars" friendlyName="QES What's New Webinars" enableHyperlink={true} />
                </Accordion>
                <Accordion title="QES Web Learning Series" testId="edit-tutorials__web-learning-series-accordion">
                  <EditTutorialsList containerName="web-learning-series" friendlyName="QES Web Learning Series" enableHyperlink={true} />
                </Accordion>
              </AccordionContainer>
            </div>
          </div>
        </PageSection>

        <PageSection>
          <div className="col-12 col-sm-8">
            {renderHeaderRow("Guides")}
            {subHeadingRow("Quest Analytics Suite")}
            <EditTutorialsList containerName="qas-user-guides" friendlyName="Quest Analytics Suite Guides"/>
            <br/>
            {subHeadingRow("Quest Enterprise Services")}
            <EditTutorialsList containerName="qes-user-guides" friendlyName="Quest Enterprise Services Guide" editOnly={true}/>
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
}

const subHeadingRow = (title: string) => (
  <div className="row">
    <div className="col-12">
      <p className="h6 mb0">{title}</p>
    </div>
  </div>
);

function renderHeaderRow(rowTitle: string) {
  return (
    <div className="row">
      <div className="col-12">
        <p className="lead mb0">{rowTitle} </p>
        <hr className="mt0" />
      </div >
    </div >
  );
}

export { EditTutorials };
